import React from 'react';
import '../styles/EventsStyle.css';
import {
    FaTwitter,
    FaFacebook,
    FaLinkedin,
    FaYoutube,
    FaChevronCircleRight,
    FaArrowRight,
    FaUser,
    FaPen,
} from 'react-icons/fa';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

export default function Opportunities({ jobPostings }) {
    const navigate = useNavigate();

    let filterd_jobPostings = jobPostings?.filter(
        (item) => new Date(item?.dueDate).getDate() >= new Date().getDate()
    );

    return (
        <div className='job_posts'>
            <div className='empty-events-container'>
                {filterd_jobPostings?.length > 0 ? (
                    filterd_jobPostings.map((item, index) => (
                        <div
                            className='upcoming-event-item'
                            key={`item-${item?.uuid}-${index}`}
                            onClick={() => navigate(`/jobpostDetail/${item?.uuid}`)}
                        >
                            <div className='left'>
                                <span
                                    className='upcoming-event-color'
                                    style={{ backgroundColor: 'darkblue' }}
                                ></span>

                                <div className='upcoming-event-detail'>
                                    <span className='upcoming-event-title'>
                                        {item?.companyName || 'Job Post'}
                                    </span>
                                    <span className='upcoming-event-date'>
                                        Required Position: {item?.positionName}
                                    </span>
                                    <span className='upcoming-event-date'>
                                        Closes:{' '}
                                        {moment(new Date(item?.dueDate).toISOString()).fromNow()}
                                        {/* {moment(new Date(item?.dueDate).toISOString()).calendar()} */}
                                        {/* {item?.dueDate} */}
                                    </span>
                                </div>
                            </div>

                            <FaChevronCircleRight size={20} />
                        </div>
                    ))
                ) : (
                    <>
                        <p className='events-empty-text'>
                            No Job Vacancies available at the moment!
                        </p>

                        <div
                            xyz='fade large duration-20  iterate-infinite'
                            className='events-emptyEmojisDiv'
                        >
                            <p className='events-emptyEmojis xyz-nested'>😴</p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
